// Placeholder for data management utilities
// This could involve fetching data from an API, managing local storage, etc.

export const sampleData = {
  // example data structure
};

/**
 * Excel 'AV80:AV108' 범위 (Column 48)의 표준 동력값들
 * VBA pwfuc 함수에서 계산된 pw 값으로 매치하여 이 값들을 반환
 * VBA의 MATCH 함수(match_type=1)가 올바르게 동작하려면 이 배열은 반드시 오름차순으로 정렬되어 있어야 합니다.
 */
export const rtsPwfucLookupData: number[] = [
    0.01, 0.02, 0.04, 0.08, 0.1, 0.2, 0.4, 0.75, 1.1, 1.5, 1.9, 2.2, 3.7, 5.5, 7.5, 11, 15, 19, 22, 30, 37, 45, 55, 75, 90, 110, 150, 190, 220
];
